"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadGranteeOptionsPromise = void 0;
var tslib_1 = require("tslib");
var utils_1 = require("../utils");
var shareDialogMappers_1 = require("../../shareDialogMappers");
var createErrorOption = function (intl) {
    return [
        {
            isDisabled: true,
            type: "error",
            label: intl.formatMessage({
                id: "shareDialog.share.grantee.add.search.error.message",
            }),
        },
    ];
};
var matchAllGroupQueryString = function (query, allGroupLabel) {
    return allGroupLabel.toLocaleLowerCase().indexOf(query.toLocaleLowerCase()) > -1;
};
/**
 * @internal
 */
exports.loadGranteeOptionsPromise = function (currentUserRef, appliedGrantees, backend, workspace, intl) {
    return function (inputValue) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var usersOption, groupsOption, workspaceUsersQuery, workspaceGroupsQuery, _a, workspaceUsers, workspaceGroups, mappedUsers, mappedGroups, allGroupLabel, groupAllOption, _b;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    usersOption = {};
                    groupsOption = {};
                    if (inputValue) {
                        usersOption = tslib_1.__assign(tslib_1.__assign({}, usersOption), { search: "%" + inputValue });
                        groupsOption = tslib_1.__assign(tslib_1.__assign({}, groupsOption), { search: "" + inputValue });
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    workspaceUsersQuery = backend.workspace(workspace).users().withOptions(usersOption).query();
                    workspaceGroupsQuery = backend.workspace(workspace).userGroups().query(groupsOption);
                    return [4 /*yield*/, Promise.all([
                            workspaceUsersQuery,
                            workspaceGroupsQuery,
                        ])];
                case 2:
                    _a = tslib_1.__read.apply(void 0, [_c.sent(), 2]), workspaceUsers = _a[0], workspaceGroups = _a[1];
                    mappedUsers = workspaceUsers.items
                        .map(function (item) { return shareDialogMappers_1.mapWorkspaceUserToGrantee(item, currentUserRef); })
                        .sort(utils_1.sortGranteesByName(intl))
                        .map(function (user) {
                        return {
                            label: utils_1.getGranteeLabel(user, intl),
                            value: user,
                        };
                    });
                    mappedGroups = workspaceGroups.items
                        .map(shareDialogMappers_1.mapWorkspaceUserGroupToGrantee)
                        .sort(utils_1.sortGranteesByName(intl))
                        .map(function (group) {
                        return {
                            label: utils_1.getGranteeLabel(group, intl),
                            value: group,
                        };
                    });
                    allGroupLabel = utils_1.getGranteeLabel(utils_1.GranteeGroupAll, intl);
                    if (!utils_1.hasGroupAll(appliedGrantees) && matchAllGroupQueryString(inputValue, allGroupLabel)) {
                        groupAllOption = {
                            label: allGroupLabel,
                            value: utils_1.GranteeGroupAll,
                        };
                        mappedGroups = tslib_1.__spread([groupAllOption], mappedGroups);
                    }
                    return [2 /*return*/, [
                            {
                                label: intl.formatMessage({ id: "shareDialog.share.grantee.add.label.group" }),
                                options: mappedGroups,
                            },
                            {
                                label: intl.formatMessage({ id: "shareDialog.share.grantee.add.label.user" }),
                                options: mappedUsers,
                            },
                        ]];
                case 3:
                    _b = _c.sent();
                    return [2 /*return*/, createErrorOption(intl)];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
//# sourceMappingURL=loadGranteeOptionsPromise.js.map